import { render, staticRenderFns } from "./pickDetail.vue?vue&type=template&id=3e045706&scoped=true&lang=true&"
import script from "./pickDetail.vue?vue&type=script&lang=js&"
export * from "./pickDetail.vue?vue&type=script&lang=js&"
import style0 from "./pickDetail.vue?vue&type=style&index=0&id=3e045706&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e045706",
  null
  
)

export default component.exports